const getDate = (dateTimeStamp, isDutchDateString = false, isUTCDate = true) => {
    if (!dateTimeStamp) {
        return "";
    }

    let date = new Date(dateTimeStamp);
    if (isDutchDateString) {
        let chunks = dateTimeStamp.split("-").map(i => parseInt(i));
        let day = chunks[0];
        let zeroIndexedMonth = chunks[1] - 1;
        let year = chunks[2]
        date = new Date(year, zeroIndexedMonth, day);
    }

    let options;
    if (isUTCDate) {
        options = {day: "2-digit", month: "short", year: "numeric", timeZone: "UTC"};
    } else {
        options = {day: "2-digit", month: "short", year: "numeric"};
    }

    return date.toLocaleDateString('nl-NL', options).split('.').join("");
};

const getDateToDigits = (dateTimeStamp, isDutchDateString = false, isUTCDate = true) => {
    let date = new Date(dateTimeStamp);
    if (isDutchDateString) {
      let chunks = dateTimeStamp.split("-").map(i => parseInt(i));
      let day = chunks[0];
      let zeroIndexedMonth = chunks[1] - 1;
      let year = chunks[2]
      date = new Date(year, zeroIndexedMonth, day);
    }

    let options;
    if (isUTCDate) {
        options = {day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC"};
    } else {
        options = {day: "2-digit", month: "2-digit", year: "numeric"};
    }

    return date.toLocaleDateString('nl-NL', options);
};

const getTime = (dateTimeStamp, isUTCTime = true) => {
    const date = new Date(dateTimeStamp);

    let options;
    if (isUTCTime) {
        options = {hour: "2-digit", minute: "2-digit", timeZone: "UTC"};    
    } else {
        options = {hour: "2-digit", minute: "2-digit"};
    }
    
    return date.toLocaleTimeString('nl-NL', options);
};

const dayNight = dateTimeStamp => {
    const date = new Date(dateTimeStamp);
    const hours = date.getHours();
    return (hours >= 6 && hours < 18);
};

const isValidDate = (dateTimeStamp) => {
    const date = new Date(dateTimeStamp);
    return (date instanceof Date) && (!isNaN(date.valueOf()) && (date.getFullYear() > 1));
}

export {getDate, getDateToDigits, getTime, dayNight, isValidDate}